import { Box, Collapse, CircularProgress } from '@material-ui/core'
import React from 'react'
import POTabs from './POTabs'

const CollapsePODetails = (props) => {
    const { open, row, handleRefresh, handleQuickSummaryRefresh, openedPOTab, handleOpenPOTab, showPencilIcon, slDetails, slDetailsLoading } = props;
    // console.log("row from collapseable",row)
    // console.log("showPencilIcon fro collapsable",props.showPencilIcon)
    // console.log("slDetails from collapseable",slDetails)

    // Only show the spinner on the initial load (no data yet).
    // Subsequent refreshes (e.g. after rejection) keep POTabs mounted so
    // local state like rejectionNote is not lost.
    const isInitialLoading = slDetailsLoading && !slDetails;

  return (
    <Collapse in={open} timeout="auto" unmountOnExit>
                    <Box margin={2}>
                      {isInitialLoading ? (
                        <Box display="flex" justifyContent="center" alignItems="center" minHeight={200}>
                          <CircularProgress />
                        </Box>
                      ) : (
                        <POTabs
                          data={row}
                          handleRefresh={handleRefresh}
                          handleQuickSummaryRefresh={handleQuickSummaryRefresh}
                          openedPOTab={openedPOTab}
                          handleOpenPOTab={handleOpenPOTab}
                          showPencilIcon={showPencilIcon}
                          slDetails={slDetails}
                        />
                      )}
                    </Box>
                  </Collapse>
  )
}

export default CollapsePODetails